import { TemplateRef } from '@angular/core';

export interface AccordionConfiguration {
  header?: string;
  headerAction?: TemplateRef<any>;
  subHeader?: string;
  customHeader?: boolean;
  icon?: string;
  hideWhenCollapsed?: boolean;
  content?: TemplateRef<any>;
  isHeaderReversed?: boolean;
  isHeaderBold?: boolean;
  card?: boolean;
  ignoreMargin?: boolean;
}
